import { Badge } from '@savvy-kit/components/badge';
import { Text } from '@savvy-kit/foundations/text';

function AssetDownloadTags({ fileTags }: { readonly fileTags: string[] }) {
  const tags = fileTags.map((tag: string) => {
    const firstChar = tag.charAt(0);
    const isFirstCharLetter = /[a-zA-Z]/.exec(firstChar);
    const formattedTag = isFirstCharLetter ? firstChar.toUpperCase() + tag.slice(1) : tag;
    return (
      <Badge variant="outline" key={tag}>
        {formattedTag}
      </Badge>
    );
  });
  return (
    <div className="flex flex-col gap-2 pt-6 pb-2 px-4 w-full">
      <Text variant="subtitle-sm">Topic</Text>
      <div className="flex flex-row gap-2 flex-wrap">{tags}</div>
    </div>
  );
}

export default AssetDownloadTags;
